export const validateSecurityDetails = (purgeDuration) => {
    if (purgeDuration < 0) {
        return 'purge duration cannot be negative value';
    }
    if (purgeDuration > 32000){
        return 'purge duration is too high';
    }
    return '';
}